module.exports = __webpack_public_path__ + "static/media/galerija_2019 (12).ce966b65.jpg";